import { makeAutoObservable, runInAction } from "mobx";

class MembershipStore {
  data = {
    show: false,
    checkstandType: "",
    position: "",
    feature: "AIIMAGE",
    source: ""
  }
  constructor() {
    makeAutoObservable(this);
  }

  setData(n) {
    if(!n) return
    runInAction(() => {
      this.data = {
        ...this.data,
        ...n
      }
    })
  }
}

const membershipStore = new MembershipStore();
export default membershipStore;